module.exports = __webpack_public_path__ + "static/media/16e-01-HOME_Chapas-2-2016-415x29mm-lapiz-portaminas-HB-sobre-papel-70gr.bfd7d50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16e/16e-01-HOME_Chapas-2-2016-415x29mm-lapiz-portaminas-HB-sobre-papel-70gr.png
// module id = 200
// module chunks = 0